import React from 'react'
import { useSelector } from 'react-redux'

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import AppBarButtons from './AppBarButtons';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';

const BottomAppBar = (props) => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');
	
	const cart = useSelector(state => state.cart.data);
	const permissions = useSelector(state => state.permissions);

	if(isSm || !permissions.cart_available || cart.length === 0){
		return null;
	}
	
	return (
		<AppBar position="fixed" 
			className={classes.bottomAppBar}
			elevation={2}
		>
			<Toolbar className={classes.toolbar}>
				<AppBarButtons 
					showCart={!isSm}
					isMain={false}
				/>
			</Toolbar>
		</AppBar>
	
)}

export default BottomAppBar